import React from 'react'
import { Text } from '@primer/react-brand'

import { PLAN_PRICES, PLAN_FEATURES, planLabel } from '../../components/subscriptionConstants'

// Sticky left-hand plan-summary card shared by the Payment (Screen 5b) and Apply
// (Screen 6) screens. Design: .apply-plan-card in Prototype C_A_primer_v2.html.
// The two screens pass different `footer` content (an info box vs. a trial note).
//
// Props: { plan, footer }  — plan is a lowercase key (e.g. 'advanced').
const PlanSummaryCard = ({ plan, footer }) => {
  const price = PLAN_PRICES[plan]
  const features = PLAN_FEATURES[plan] || []

  return (
    <div
      style={{
        background: 'var(--base-color-scale-gray-0)',
        border: '1px solid var(--base-color-scale-gray-1)',
        borderRadius: 6,
        padding: 24,
        position: 'sticky',
        top: 24,
      }}
    >
      <Text
        as="p"
        style={{
          margin: '0 0 8px',
          fontSize: 11,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          color: 'var(--base-color-scale-gray-6)',
        }}
      >
        Applying for
      </Text>
      <Text
        as="p"
        weight="semibold"
        style={{
          margin: '0 0 4px',
          fontSize: 26,
          letterSpacing: '-0.02em',
          color: 'var(--base-color-scale-gray-9)',
        }}
      >
        {planLabel(plan)}
      </Text>
      <Text
        as="p"
        style={{ margin: 0, fontSize: 15, color: 'var(--base-color-scale-gray-6)' }}
      >
        {price} / month
      </Text>

      <hr
        style={{
          border: 'none',
          borderTop: '1px solid var(--base-color-scale-gray-1)',
          margin: '18px 0',
        }}
      />

      {features.map((feature, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            gap: 7,
            marginBottom: 7,
            fontSize: 13,
            color: 'var(--base-color-scale-gray-6)',
          }}
        >
          <span style={{ color: 'var(--base-color-scale-green-5)', fontWeight: 700 }}>✓</span>
          {feature}
        </div>
      ))}

      {footer && (
        <>
          <hr
            style={{
              border: 'none',
              borderTop: '1px solid var(--base-color-scale-gray-1)',
              margin: '18px 0',
            }}
          />
          {footer}
        </>
      )}
    </div>
  )
}

export default PlanSummaryCard
